var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-ranks" },
    [
      _c(
        "div",
        { staticClass: "flex flex-center-1", staticStyle: { width: "100%" } },
        [
          _c("div", { staticClass: "shop-tab flex flex-center-1" }, [
            _c(
              "div",
              {
                staticClass: "shop-tab-item flex flex-center-1",
                class: { "shop-tab-item-active": _vm.tabActive1 == "chongzhi" },
                on: {
                  click: function ($event) {
                    return _vm.onSwtich("chongzhi")
                  },
                },
              },
              [_vm._v(" 充值额度 ")]
            ),
            _vm.hasCurrentEvents
              ? _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: {
                      "shop-tab-item-active": _vm.tabActive1 == "paihang",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onSwtich("paihang")
                      },
                    },
                  },
                  [_vm._v(" 我的排行 ")]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm.tabActive1 == "chongzhi"
        ? _c(
            "div",
            {
              staticClass: "flex flex-center-1",
              staticStyle: { width: "100%" },
            },
            [
              _c("div", { staticClass: "shop-tab flex flex-center-1" }, [
                _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: { "shop-tab-item-active": _vm.chongzhiActive == 3 },
                    on: {
                      click: function ($event) {
                        return _vm.changetab(3)
                      },
                    },
                  },
                  [_vm._v(" 日活动 ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: { "shop-tab-item-active": _vm.chongzhiActive == 1 },
                    on: {
                      click: function ($event) {
                        return _vm.changetab(1)
                      },
                    },
                  },
                  [_vm._v(" 月活动 ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "shop-tab-item flex flex-center-1",
                    class: { "shop-tab-item-active": _vm.chongzhiActive == 2 },
                    on: {
                      click: function ($event) {
                        return _vm.changetab(2)
                      },
                    },
                  },
                  [_vm._v(" 周活动 ")]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c("c-ranksItem", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tabActive1 == "chongzhi" && _vm.chongzhiActive <= 3,
            expression: "tabActive1 == 'chongzhi' && chongzhiActive <= 3",
          },
        ],
        attrs: { chongzhiActive: _vm.chongzhiActive },
        on: {
          "current-events-change": function ($event) {
            _vm.hasCurrentEvents = $event
          },
        },
      }),
      _vm.tabActive1 == "paihang" ? _c("router-view") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }